module.exports = __webpack_public_path__ + "assets/img/38_443.10e855bb.jpg";